import NewsComp from "../../components/news/NewsComp"
import { useTranslation } from "react-i18next"

export default function News009() {

    const { t } = useTranslation()

    const newsText = [
        t('news:news.9.p1'),
        t('news:news.9.p2'),
        t('news:news.9.p3'),
        t('news:news.9.p4'),
        t('news:news.9.p5'),
        t('news:news.9.p6'),
        t('news:news.9.p7'),
		t('news:news.9.p8')
    ]

    const newsImage = [
        "news009-img1.jpg",
        "news009-img2.jpg",
        "news009-img3.jpg",
        "news009-img4.jpg",
		"news009-img5.jpg",
		"news009-img6.jpg",
		"news009-img7.jpg",
		"news009-img8.jpg",
    ]
    return (
        <div>
            <NewsComp
                newsImage={newsImage}
                newsText={newsText}
                date="2026-06-01"
                headline={t('news:headline.9')}
            />
        </div>
    )
}